import ListeTargetare from "@/pages/AdministrareTargetare/pagini/ListeTargetare";

export default function ListeNeoficiale() {
  return <ListeTargetare tipFiltru="NEOFICIALA" />;
}
